<div class="page-outer-wrapper">

  <div class="admin-page-header">
    <div class="hamburger">
      <img (click)="toggleSidebar()" style="cursor: pointer;" src="/assets/images/menu-512.png" height="28" width="28">
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>

  <div class="page-content-background">

    <div class="page-content">

      <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

        <mat-sidenav #adminsidenav class="admin-sidebar">

          <admin-sidebar></admin-sidebar>

        </mat-sidenav>

        <mat-sidenav-content>

          <!-- [START] page content -->

          <mat-card style="width: 100%; display: block;">

            <mat-card-header>
              <mat-card-title>Pending Users</mat-card-title>
            </mat-card-header>

            <mat-card-content style="padding-left: 16px;">

              <p>To Approve a user click on their userid or the approve action.</p>
              <p-blockui [target]="pendingtable" [blocked]="busy" />
              <p-table class="admin-dark-table" #pendingtable selectionMode="single" sortField="userid" (sortFunction)="tableSort($event)" [customSort]="true" [value]="userList">

                <ng-template pTemplate="header">
                  <tr style="background-color: #2D323D;">
                    <th width="80">ID<p-sortIcon field="id"></p-sortIcon></th>
                    <th pSortableColumn="userid" >userid<p-sortIcon field="userid"></p-sortIcon></th>
                    <th pSortableColumn="display_name">Name<p-sortIcon field="display_name"></p-sortIcon></th>
                    <th pSortableColumn="email">eMail<p-sortIcon field="email"></p-sortIcon></th>
                    <th pSortableColumn="created_at">Requested<p-sortIcon field="created_at"></p-sortIcon></th>
                    <th>Actions</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-user>

                  <tr [className]="'userListrowWrapper'" >

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.id}}</td>

                    <td  *ngIf="user.is_pending" style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;"><a style="color: white; text-decoration: none; text-underline: none; font-weight: bold;" title="Approve User"  [routerLink]="['/administration/users/approve/', user.userid]">{{user.userid}}</a></td>

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.display_name}}</td>
                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.email}}</td>
                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{user.created_at}}</td>
                    <td style="font-size: 10px;">

                      <!-- pending users must be approved before you can do anything with them -->

                      <a title="Approve User" *ngIf="user.is_pending" class="useractionicon" [routerLink]="['/administration/users/approve/', user.userid]">
                        <img width="16" src="assets/images/check-64.png">
                      </a>

                      <a title="Reject User" *ngIf="user.is_pending" class="useractionicon" (click)="hardDeleteUser(user)">
                        <img width="16" src="assets/images/delete-64.png">
                      </a>

                    </td>
                  </tr>

                </ng-template>

              </p-table>

            </mat-card-content>

          </mat-card>

        </mat-sidenav-content>

      </mat-sidenav-container>

    </div>

    <div id="pano-footer" class="pano-footer"></div>
  </div>

</div>
